import { gql } from "@apollo/client";

/**
 * Shared image/upload file fields (url, dimensions, formats).
 * Use on UploadFile for message image, meme_icon icon, item assets, room icon/image.
 */
export const ImageFragment = gql`
    fragment ImageFragment on UploadFile {
        url
        width
        height
        formats
        updatedAt
        documentId,
        alternativeText,
        mime
    }
`;

export const RoomFragment = gql`
    fragment RoomFragment on Room {
        documentId
        name
        animated {
            ...ImageFragment
        }
        image {
            ...ImageFragment
        }
        gameOverBrokeVersion {
            ...ImageFragment
        }
        gameOverSadVersion {
            ...ImageFragment
        }
        minCashRequired
        rent
        roomTransitionText
        minDepotRequired
    }
    ${ImageFragment}
`;

/**
 * Response option on a message (stats, item reward, achievement, etc.).
 * Uses ImageFragment for item.asset_a and item.asset_b.
 */
export const ResponseFragment = gql`
    fragment ResponseFragment on ComponentResponsesResponse {
        id
        text
        icon
        happiness
        cash
        earnings
        investments
        item {
            documentId
            name
            asset_a {
                ...ImageFragment
            }
            asset_b {
                ...ImageFragment
            }
            description
            showEffect
            appearEffect {
                offsetX
                offsetY
                scale
            }
        }
        timerAutoResponse
        achievement {
            documentId
            name
        }
        financeType {
            documentId
        }
        doomspendingGameOver
    }
    ${ImageFragment}
`;
